import './CookieNotice.css';

export default function CookieNotice() {
  return (
    <div className="cookie-notice">
      <p>
        This site uses cookies from Google to analyze traffic.
        {' '}
        <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer">
          Learn more.
        </a>
      </p>
    </div>
  );
}
